<button class="btn btn-dark btn-icon" id="back-to-top" (click)="topFunction()">
    <i class="bi bi-caret-up fs-3xl"></i>
</button>

<div class="menu-wrapper">
    <header id="page-topbar" (window:scroll)="windowScroll()">
        <div class="layout-width">
            <div class="navbar-header" id="navbar-header">
                <div class="d-flex" id="header-logo">
                    <!-- LOGO -->
                    <div class="navbar-brand-box horizontal-logo">
                        <a routerLink="/" class="logo logo-dark">
                            <span class="logo-sm">
                                <img src="assets/images/alicro-sm.png" alt="" height="22">
                            </span>
                            <span class="logo-lg">
                                <img src="assets/images/alicro-dark.png" alt="" height="22">
                            </span>
                        </a>

                        <a routerLink="/" class="logo logo-light">
                            <span class="logo-sm">
                                <img src="assets/images/alicro-sm.png" alt="" height="22">
                            </span>
                            <span class="logo-lg">
                                <img src="assets/images/alicro-light.png" alt="" height="22">
                            </span>
                        </a>
                    </div>

                    <button type="button"
                        class="btn btn-sm px-3 header-item vertical-menu-btn topnav-hamburger shadow-none"
                        id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                        <span class="hamburger-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>

                </div>
                <!-- ========== App Menu ========== -->
                <div class="app-menu navbar-menu mx-auto">
                    <!-- LOGO -->
                    <div class="navbar-brand-box vertical-logo">
                        <a href="index.html" class="logo logo-dark">
                            <span class="logo-sm">
                                <img src="assets/images/alicro-sm.png" alt="" height="22">
                            </span>
                            <span class="logo-lg">
                                <img src="assets/images/alicro-dark.png" alt="" height="22">
                            </span>
                        </a>

                        <a href="index.html" class="logo logo-light">
                            <span class="logo-sm">
                                <img src="assets/images/alicro-sm.png" alt="" height="22">
                            </span>
                            <span class="logo-lg">
                                <img src="assets/images/alicro-light.png" alt="" height="22">
                            </span>
                        </a>
                    </div>
                    <div id="scrollbar" class="h-100 simplebar-scrollable-y">
                        <ul class="navbar-nav" id="navbar-nav">
                            @for(item of menuItems;track $index){
                            <ng-container>
                                <li class="nav-item">

                                    @if(hasItems(item)){
                                    <a class="nav-link menu-link" href="javascript:void(0);" data-bs-toggle="collapse"
                                        role="button" aria-expanded="false" (click)="toggleItem($event)">
                                        <i class="{{item.icon}}"></i> <span>{{ item.label | translate }}</span>
                                    </a>
                                    <div class="collapse menu-dropdown"
                                        [ngClass]="{'mega-dropdown-menu':item.label === 'bootstrap-ui'}"
                                        id="sidebarMultilevel">
                                        <div [ngClass]="{'row':item.label == 'bootstrap-ui'}">
                                            @for (subitem of item.subItems; track $index) {
                                            <div [ngClass]="{'col-lg-4': item.label == 'bootstrap-ui'}">
                                                @if(hasItems(item)){
                                                <ul class="nav nav-sm flex-column">
                                                    <li class="nav-item">

                                                        @if(hasItems(subitem)){
                                                        <a href="javascript:void(0);" class="nav-link"
                                                            data-bs-toggle="collapse" role="button"
                                                            aria-expanded="false" (click)="toggleSubItem($event)"> {{
                                                            subitem.label | translate}}
                                                        </a>}@else {
                                                        <a [routerLink]="subitem.link" class="nav-link"
                                                            (click)="updateActive($event)"> {{
                                                            subitem.label | translate}} </a>
                                                        }
                                                        @if(hasItems(subitem)){
                                                        <div class="collapse menu-dropdown" id="sidebarAccount">
                                                            @if(hasItems(item)){
                                                            <ul class="nav nav-sm flex-column">
                                                                @for (subSubitem of subitem.subItems; track $index) {
                                                                <li class="nav-item">
                                                                    @if(subSubitem.childItem){
                                                                    <a href="javascript:void(0);" class="nav-link"
                                                                        data-bs-toggle="collapse" role="button"
                                                                        aria-expanded="false" aria-controls="sidebarCrm"
                                                                        (click)="toggleSubItem($event)"> {{
                                                                        subSubitem.label | translate }}
                                                                    </a>

                                                                    <div class="collapse menu-dropdown" id="sidebarCrm">
                                                                        <ul class="nav nav-sm flex-column">
                                                                            @for (subChilditem of subSubitem.childItem;
                                                                            track $index) {
                                                                            <li class="row" class="nav-item">
                                                                                @if(subChilditem.childItem){
                                                                                <a [attr.data-parent]="subSubitem.parentId"
                                                                                    [routerLink]="subChilditem.link"
                                                                                    data-bs-toggle="collapse"
                                                                                    aria-expanded="false"
                                                                                    class="nav-link"
                                                                                    (click)="updateActive($event)">
                                                                                    {{ subChilditem.label | translate }}
                                                                                </a>

                                                                                <div class="collapse menu-dropdown">
                                                                                    <ul class="nav nav-sm flex-column"
                                                                                        aria-expanded="false">
                                                                                        @for (subchildChilditem of
                                                                                        subChilditem.childItem; track
                                                                                        $index) {
                                                                                        <li class="nav-item">

                                                                                            <a [attr.data-parent]="subchildChilditem.parentId"
                                                                                                [routerLink]="subchildChilditem.link"
                                                                                                class="nav-link"
                                                                                                (click)="updateActive($event)">
                                                                                                {{
                                                                                                subchildChilditem.label
                                                                                                | translate }}
                                                                                            </a>

                                                                                        </li>
                                                                                        }
                                                                                    </ul>
                                                                                </div>}@else {
                                                                                <a [routerLink]="subChilditem.link"
                                                                                    class="nav-link"
                                                                                    (click)="updateActive($event)"> {{
                                                                                    subChilditem.label | translate }}
                                                                                </a>}
                                                                            </li>
                                                                            }
                                                                        </ul>
                                                                    </div>}@else {
                                                                    <a [routerLink]="subSubitem.link" class="nav-link"
                                                                        (click)="updateActive($event)"> {{
                                                                        subSubitem.label | translate }} </a>
                                                                    }

                                                                </li>
                                                                }
                                                            </ul>
                                                            }
                                                        </div>
                                                        }
                                                    </li>
                                                </ul>
                                                }
                                            </div>

                                            }
                                        </div>
                                    </div>
                                    }@else {
                                    <a [routerLink]="item.link" class="nav-link menu-link"
                                        (click)="updateActive($event)" href="javascript:void(0);">
                                        <i class="{{item.icon}}"></i> <span>{{ item.label | translate }}</span>
                                    </a>
                                    }
                                </li>
                            </ng-container>
                            }
                            @if(userData?.userType === 'P'){
                            <li class="nav-item">
                              <a routerLink="/perfil-sociodemografico/mi-perfil" class="nav-link menu-link"
                                (click)="updateActive($event)" href="javascript:void(0);">
                                <i class="bx bx-id-card"></i> <span>Mi Perfil</span>
                              </a>
                            </li>
                            }
                        </ul>
                    </div>
                </div>

                <div class="d-flex align-items-center" id="header-items">

                    <!-- <div dropdown container="body" class="dropdown ms-1 topbar-head-dropdown header-item">
                        <button dropdownToggle type="button" class="btn btn-icon btn-topbar rounded-circle" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bx bx-search align-middle fs-3xl"></i>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
                            <form class="p-3">
                                <div class="form-group m-0">
                                    <div class="input-group">
                                        <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                                        <button class="btn btn-primary" type="submit"><i class="bi bi-search"></i></button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div dropdown container="body" class="dropdown ms-1 topbar-head-dropdown header-item">
                        <button dropdownToggle type="button" class="btn btn-icon btn-topbar rounded-circle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            @if(flagvalue == undefined){
                            <img id="header-lang-img" src="{{valueset}}" alt="Header Language" height="20" class="rounded">
                            }@else {
                            <img id="header-lang-img" src="{{flagvalue}}" alt="Header Language" height="20" class="rounded">
                            }
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-end">

                            @for (item of listLang; track $index) {
                            <a href="javascript:void(0);" class="dropdown-item notify-item language py-2" (click)="setLanguage(item.text, item.lang, item.flag)">
                                <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18">
                                <span class="align-middle">{{item.text}}</span>
                            </a>}
                        </div>
                    </div>

                    <div dropdown container="body" class="dropdown topbar-head-dropdown ms-1 header-item">
                        <button dropdownToggle type="button" class="btn btn-icon btn-topbar rounded-circle mode-layout" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="bi bi-sun align-middle fs-3xl"></i>
                        </button>
                        <div *dropdownMenu class="dropdown-menu p-2 dropdown-menu-end" id="light-dark-mode">
                            <a href="javascript:void(0);" class="dropdown-item" data-mode="light" (click)="changeMode('light')"><i class="bi bi-sun align-middle me-2"></i> Default (light
                                mode)</a>
                            <a href="javascript:void(0);" class="dropdown-item" data-mode="dark" (click)="changeMode('dark')"><i class="bi bi-moon align-middle me-2"></i> Dark</a>
                            <a href="javascript:void(0);" class="dropdown-item" data-mode="brand" (click)="changeMode('brand')"><i class="bi bi-award align-middle me-2"></i> Brand</a>
                            <a href="javascript:void(0);" class="dropdown-item" data-mode="auto" (click)="changeMode('light')"><i class="bi bi-moon-stars align-middle me-2"></i> Auto
                                (system default)</a>
                        </div>
                    </div>

                    <div dropdown [insideClick]="true" container="body" class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
                        <button dropdownToggle type="button" class="btn btn-icon btn-topbar rounded-circle" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                            <i class='bi bi-bell fs-2xl'></i>
                            <span class="position-absolute topbar-badge p-0 d-flex align-items-center justify-content-center translate-middle badge rounded-pill bg-danger"><span class="notification-badge">{{badgeContent}}</span><span class="visually-hidden">unread
                                    messages</span></span>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">

                            <div class="dropdown-head rounded-top">
                                <div class="p-3 pb-1">
                                    <div class="row align-items-center mb-3">
                                        <div class="col">
                                            <h6 class="mb-0 fs-lg fw-semibold"> Notifications <span class="badge bg-danger-subtle text-danger fs-sm notification-badge">
                                                    {{badgeContent}}</span></h6>
                                        </div>
                                        <div dropdown class="col-auto dropdown">
                                            <a dropdownToggle href="javascript:void(0);" data-bs-toggle="dropdown" class="link-secondary fs-md"><i class="bi bi-three-dots-vertical"></i></a>
                                            <ul *dropdownMenu class="dropdown-menu">
                                                <li><a class="dropdown-item" href="javascript:void(0);" (click)="toggleClass()">All Clear</a>
                                                </li>
                                                <li><a class="dropdown-item" href="javascript:void(0);" (click)="toggleMark()">Mark all as
                                                        read</a></li>
                                                <li><a class="dropdown-item" href="javascript:void(0);">Archive All</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card border-top border-bottom mb-0 rounded-0">
                                <div class="p-3 d-flex align-items-center gap-2">
                                    <div class="flex-shrink-0">
                                        <i class="bi bi-bell fs-3xl"></i>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Push Notification</h6>
                                        <p class="text-muted mb-0">Automatically send new notification</p>
                                    </div>
                                    <div class="flex-shrink-0">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="py-2 ps-3" id="notificationItemsTabContent" [style.display]="isIdVisible ? 'block' : 'none'">
                                <ngx-simplebar style=" max-height: 300px;" class="pe-3">
                                    <div class="text-reset notification-item d-block dropdown-item position-relative unread-message" id="notificationItemsTabContent">
                                        <div class="d-flex gap-3">
                                            <div class="flex-shrink-0">
                                                <img src="assets/images/companies/img-3.png" class="rounded-circle avatar-xs" alt="Notification Images">
                                            </div>
                                            <div class="flex-grow-1">
                                                <a href="javascript:void(0);" class="stretched-link">
                                                    <h6 class="fs-md mb-1 lh-base">Judia Membership</h6>
                                                </a>
                                                <p class="text-muted mb-0">Successfully purchased a business plan for
                                                    <span class="text-danger fw-medium">-$24.99</span>
                                                </p>
                                            </div>
                                            <p class="mb-0 fs-xs fw-medium flex-shrink-0 text-muted">
                                                57 sec ago
                                            </p>
                                        </div>
                                    </div>

                                    <div class="text-reset notification-item d-block dropdown-item position-relative">
                                        <div class="d-flex gap-3">
                                            <div class="flex-shrink-0">
                                                <img src="assets/images//users/avatar-8.jpg" class="rounded-circle avatar-xs" alt="Notification Images">
                                            </div>
                                            <div class="flex-grow-1">
                                                <a href="javascript:void(0);" class="stretched-link">
                                                    <h6 class="fs-md mb-1 lh-base">Bella Bailey</h6>
                                                </a>
                                                <p class="text-muted mb-0">Assigned you on the call with Fatima</p>
                                            </div>
                                            <p class="mb-0 fs-xs fw-medium flex-shrink-0 text-muted">
                                                5 min ago
                                            </p>
                                        </div>
                                    </div>

                                    <div class="text-reset notification-item d-block dropdown-item position-relative">
                                        <div class="d-flex gap-3">
                                            <div class="avatar-xs flex-shrink-0">
                                                <span class="avatar-title bg-danger-subtle text-danger rounded-circle fs-lg">
                                                    <i class='bx bx-message-square-dots'></i>
                                                </span>
                                            </div>
                                            <div class="flex-grow-1">
                                                <p class="text-muted mb-0"><b class="text-body">Nathan Keeling</b>
                                                    replied to your comment on <b>Steex - Admin & Dashboards</b></p>
                                            </div>
                                            <p class="mb-0 fs-xs fw-medium flex-shrink-0 text-muted">
                                                3 hrs ago
                                            </p>
                                        </div>
                                    </div>

                                    <div class="text-reset notification-item d-block dropdown-item position-relative">
                                        <div class="d-flex gap-3">
                                            <div class="position-relative flex-shrink-0">
                                                <img src="assets/images//users/avatar-2.jpg" class="rounded-circle avatar-xs" alt="Notification Images">
                                                <span class="active-badge position-absolute start-100 translate-middle p-1 bg-success rounded-circle">
                                                    <span class="visually-hidden">New alerts</span>
                                                </span>
                                            </div>
                                            <div class="flex-grow-1">
                                                <a href="javascript:void(0);" class="stretched-link">
                                                    <h6 class="fs-md mb-1 lh-base">Angela Bernier</h6>
                                                </a>
                                                <p class="text-muted mb-0">Answered to your comment on the cash flow
                                                    forecast's graph 🔔.</p>
                                            </div>
                                            <p class="mb-0 fs-xs fw-medium flex-shrink-0 text-muted">
                                                1 week ago
                                            </p>
                                        </div>
                                    </div>

                                    <div class="text-reset notification-item d-block dropdown-item position-relative">
                                        <div class="d-flex gap-3">
                                            <div class="position-relative flex-shrink-0">
                                                <img src="assets/images//users/avatar-3.jpg" class="rounded-circle avatar-xs" alt="Notification Images">
                                                <span class="active-badge position-absolute start-100 translate-middle p-1 bg-warning rounded-circle">
                                                    <span class="visually-hidden">New alerts</span>
                                                </span>
                                            </div>
                                            <div class="flex-grow-1">
                                                <a href="javascript:void(0);" class="stretched-link">
                                                    <h6 class="fs-md mb-1 lh-base">Maureen Gibson</h6>
                                                </a>
                                                <p class="text-muted mb-0">We talked about a project on linkedin.</p>
                                            </div>
                                            <p class="mb-0 fs-xs fw-medium flex-shrink-0 text-muted">
                                                2 week ago
                                            </p>
                                        </div>
                                    </div>
                                </ngx-simplebar>
                            </div>
                            <div class="empty-notification-elem text-center px-4" [style.display]="isClassVisible ? 'block' : 'none'">
                                <div class="mt-3 avatar-md mx-auto">
                                    <div class="avatar-title bg-info-subtle text-info fs-24 rounded-circle"> <i class="bi bi-bell "></i> </div>
                                </div>
                                <div class="pb-3 mt-2">
                                    <h6 class="fs-lg fw-semibold lh-base">Hey! You have no any notifications </h6>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div dropdown container="body" class="dropdown topbar-head-dropdown ms-2 header-item">
                        <button dropdownToggle type="button" class="btn btn-icon rounded-circle"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img class="rounded-circle img-fluid"
                                [src]="authService.getLoggedUser()?.imgProfile !== '' ? backendUrl+authService.getLoggedUser()?.imgProfile : 'assets/images/users/user-dummy-img.jpg'"
                                alt="Header Avatar">
                        </button>
                        <div *bsDropdownMenu class="dropdown-menu p-2 dropdown-menu-end" style="width: 260px;">
                            <div class="d-flex gap-2 mb-3 topbar-profile">
                                <div class="position-relative flex-shrink-0">
                                    <img class="rounded-circle avatar-sm object-fit-cover"
                                        [src]="authService.getLoggedUser()?.imgProfile ? backendUrl + authService.getLoggedUser()?.imgProfile : 'assets/images/users/user-dummy-img.jpg'"
                                        alt="Header Avatar">
                                </div>
                                <div class="flex-grow-1 overflow-hidden">
                                    <h6 class="mb-0 fs-sm user-name text-truncate">{{userData?.displayName}}</h6>
                                    <p class="mb-0 fs-xs text-muted text-truncate">{{userData?.role}}</p>
                                </div>
                            </div>
                            <div class="dropdown-divider"></div>
                            <a [routerLink]="['/auth/pass-change', userData?.userId]" class="dropdown-item">
                                <i class="bi bi-lock align-middle me-2"></i>Cambiar Contraseña
                            </a>
                            <div class="dropdown-divider"></div>
                            <a routerLink="/auth/logout" class="dropdown-item text-danger">
                                <i class="bi bi-box-arrow-right align-middle me-2"></i>Cerrar Sesión
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- removeNotificationModal -->
    <div bsModal #removeNotificationModal="bs-modal" id="removeNotificationModal" class="modal fade zoomIn"
        tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" (click)="removeNotificationModal.hide()"
                        id="NotificationModalbtn-close"></button>
                </div>
                <div class="modal-body p-md-5">
                    <div class="text-center">
                        <div class="text-danger">
                            <i class="bi bi-trash display-4"></i>
                        </div>
                        <div class="mt-4 fs-base">
                            <h4 class="mb-1">Are you sure ?</h4>
                            <p class="text-muted mx-4 mb-0">Are you sure you want to remove this Notification ?</p>
                        </div>
                    </div>
                    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button type="button" class="btn w-sm btn-light"
                            (click)="removeNotificationModal.hide()">Close</button>
                        <button type="button" class="btn w-sm btn-danger" id="delete-notification">Yes, Delete
                            It!</button>
                    </div>
                </div>

            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- removeCartModal -->
    <div bsModal #removeCartModal="bs-modal" id="removeCartModal" class="modal fade zoomIn" tabindex="-1"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" (click)="removeCartModal.hide()"
                        id="close-cartmodal"></button>
                </div>
                <div class="modal-body p-md-5">
                    <div class="text-center">
                        <div class="text-danger">
                            <i class="bi bi-trash display-5"></i>
                        </div>
                        <div class="mt-4">
                            <h4>Are you sure ?</h4>
                            <p class="text-muted mx-4 mb-0">Are you sure you want to remove this product ?</p>
                        </div>
                    </div>
                    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                        <button type="button" class="btn w-sm btn-light" (click)="removeCartModal.hide()">Close</button>
                        <button type="button" class="btn w-sm btn-danger" id="remove-cartproduct">Yes, Delete
                            It!</button>
                    </div>
                </div>

            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</div>